import { memo } from 'react'
import { useQuery } from '@tanstack/react-query'
import type { Language } from '../../../hooks/language/use-translate'
import { useTranslate } from '../../../hooks/language/use-translate'
import { gameGoldMinerService } from '../../../services/games/games-golds-miners'
import closeSvg from '../modal-games/components/images/close.svg'

interface Props {
  onClose: () => void
}

export const ModalRewards = memo(({ onClose }: Props) => {
  const { translate } = useTranslate()
  const title = translate('modal-game-gold-miner-prize' as Language)

  // pool real de prêmios (games_golds_miners_gifts + gifts), já ordenado por valor desc
  const { data: prizes = [] } = useQuery({
    queryKey: ['gold-miner-prizes'],
    queryFn: () => gameGoldMinerService.getGifts(),
  })

  return (
    <div className="absolute inset-0 z-30 flex flex-col overflow-hidden rounded-t-2xl bg-gradient-to-b from-[#241706] to-black">
      {/* header */}
      <div className="relative flex items-center justify-center px-4 pt-4 pb-3">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-white/10 px-2 py-0.5 text-[11px] font-bold text-white/80">
          {prizes.length}
        </span>
        <h2 className="text-lg font-extrabold tracking-wide text-amber-300 drop-shadow">
          {title}
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-1/2 -translate-y-1/2"
        >
          <img src={closeSvg} alt="Fechar" className="h-4 w-4" />
        </button>
      </div>

      {/* grid de prêmios: img – name – valor */}
      <div className="flex-1 overflow-y-auto px-3 pb-6">
        <div className="grid grid-cols-3 gap-2.5">
          {prizes.map((p) => (
            <div
              key={p.id}
              className="flex flex-col items-center rounded-xl border border-amber-400/15 bg-white/5 p-2"
            >
              <img
                src={p.imgGiftFrame ?? p.imgGift ?? ''}
                alt={p.giftName}
                className="h-14 w-14 object-contain"
              />
              <span className="mt-1 w-full truncate text-center text-[10px] font-medium text-white/70">
                {p.giftName}
              </span>
              <span className="mt-0.5 text-xs font-bold text-amber-300">
                {p.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})

ModalRewards.displayName = 'ModalRewards'
